window.addEventListener('load', (event) => {
  if (Cookies.get('site_cookies_consented')) {
    return;
  }
  let $consent_box = document.querySelector('.cookie-consent');
  $consent_box.classList.add('show');
  $consent_box.querySelector('.button--accept').addEventListener('click', (e) => {
    e.preventDefault();
    Cookies.set('site_cookies_consented', Date.now(), { expires: 365 });
    $consent_box.classList.remove('show');
  });
});
/*! js-cookie v3.0.1 | MIT */
!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define(t)
    : ((e = e || self),
      (function () {
        var n = e.Cookies,
          o = (e.Cookies = t());
        o.noConflict = function () {
          return (e.Cookies = n), o;
        };
      })());
})(this, function () {
  'use strict';
  function e(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) e[o] = n[o];
    }
    return e;
  }
  return (function t(n, o) {
    function r(t, r, i) {
      if ('undefined' != typeof document) {
        'number' == typeof (i = e({}, o, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)),
          i.expires && (i.expires = i.expires.toUTCString()),
          (t = encodeURIComponent(t)
            .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
            .replace(/[()]/g, escape));
        var c = '';
        for (var u in i) i[u] && ((c += '; ' + u), !0 !== i[u] && (c += '=' + i[u].split(';')[0]));
        return (document.cookie = t + '=' + n.write(r, t) + c);
      }
    }
    return Object.create(
      {
        set: r,
        get: function (e) {
          if ('undefined' != typeof document && (!arguments.length || e)) {
            for (var t = document.cookie ? document.cookie.split('; ') : [], o = {}, r = 0; r < t.length; r++) {
              var i = t[r].split('='),
                c = i.slice(1).join('=');
              try {
                var u = decodeURIComponent(i[0]);
                if (((o[u] = n.read(c, u)), e === u)) break;
              } catch (e) {}
            }
            return e ? o[e] : o;
          }
        },
        remove: function (t, n) {
          r(t, '', e({}, n, { expires: -1 }));
        },
        withAttributes: function (n) {
          return t(this.converter, e({}, this.attributes, n));
        },
        withConverter: function (n) {
          return t(e({}, this.converter, n), this.attributes);
        },
      },
      { attributes: { value: Object.freeze(o) }, converter: { value: Object.freeze(n) } },
    );
  })(
    {
      read: function (e) {
        return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      },
      write: function (e) {
        return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
      },
    },
    { path: '/' },
  );
});

// JQuery Visible
!(function (t) {
  var i = t(window);
  t.fn.visible = function (t, e, o) {
    if (!(this.length < 1)) {
      var r = this.length > 1 ? this.eq(0) : this,
        n = r.get(0),
        f = i.width(),
        h = i.height(),
        o = o ? o : 'both',
        l = e === !0 ? n.offsetWidth * n.offsetHeight : !0;
      if ('function' == typeof n.getBoundingClientRect) {
        var g = n.getBoundingClientRect(),
          u = g.top >= 0 && g.top < h,
          s = g.bottom > 0 && g.bottom <= h,
          c = g.left >= 0 && g.left < f,
          a = g.right > 0 && g.right <= f,
          v = t ? u || s : u && s,
          b = t ? c || a : c && a;
        if ('both' === o) return l && v && b;
        if ('vertical' === o) return l && v;
        if ('horizontal' === o) return l && b;
      } else {
        var d = i.scrollTop(),
          p = d + h,
          w = i.scrollLeft(),
          m = w + f,
          y = r.offset(),
          z = y.top,
          B = z + r.height(),
          C = y.left,
          R = C + r.width(),
          j = t === !0 ? B : z,
          q = t === !0 ? z : B,
          H = t === !0 ? R : C,
          L = t === !0 ? C : R;
        if ('both' === o) return !!l && p >= q && j >= d && m >= L && H >= w;
        if ('vertical' === o) return !!l && p >= q && j >= d;
        if ('horizontal' === o) return !!l && m >= L && H >= w;
      }
    }
  };
})(jQuery);
(function ($) {
  $(function () {
    modalActions();
    initPreTags();
  });

  function initPreTags() {
    $('.blog-layout').find('pre').addClass('prettyprint');
  }

  var youtubeid = false;
  function modalActions() {
    $('.modal').on('click', function (e) {
      e.preventDefault();

      $($(this).attr('href')).addClass('open');
      $('body').addClass('modal_open');
      if ($(this).hasClass('video')) {
        loadYoutubeAPI($(this));
      }
    });

    $('.close_modal').on('click', function (e) {
      e.preventDefault();
      $($(this).attr('href')).removeClass('open');
      $('body').removeClass('modal_open');
      if ($player) {
        $player.pauseVideo();
      }
    });
  }

  $(window).on('load', function () {
    var $article_next_link = $('.article-next-link');
    if ($article_next_link.length) {
      var $prev = $article_next_link.prev(), //Div before .article-next-link
        $prev_bottom = parseInt($prev.offset().top + $prev.height()), // div top plus div height
        $el = $('.button--comments'),
        $el_top = parseInt($el.offset().top + $el.height()),
        $window = $(window),
        $window_height = parseInt($window.height()),
        $window_half_height = parseInt($window_height / 2);
      $window.on('scroll', function () {
        if ($window.scrollTop() > $prev_bottom - $window_height && $window.scrollTop() < $el_top - $window_half_height) {
          $article_next_link.addClass('active');
        } else {
          $article_next_link.removeClass('active');
        }
      });
    }

    var $search_panel = $('.search-panel'),
      $results = $search_panel.find('.results'),
      $SearchForm = $('#SearchForm'),
      $s = $SearchForm.find('#s');
    //console.log($SearchForm);
    $SearchForm.on('submit', function (e) {
      $search_panel.addClass('loading');
      e.preventDefault();
      var $request = $.ajax({
        url: window.theme_ajax.ajax_url,
        type: 'post',
        data: {
          action: 'leadingagile_search',
          s: $s.val(),
        },
      });

      dataLayer.push({
        event: 'customSearch',
        customSearchInput: $s.val(),
      });

      $request.always(function (msg) {
        $search_panel.removeClass('loading');
      });

      $request.done(function (response) {
        let $json = JSON.parse(response);
        console.log($json);
        if ($json.no_results) {
          $results.html($json.no_results);
        } else {
          $results.html($json.posts);
        }
      });

      $request.fail(function (jqXHR, textStatus) {
        console.log('Request failed: ' + textStatus);
      });
    });
  });

  /*   var autocompleteloaded = false;

  function initAutocomplete(selector = 'input[name=s]', formId = "'#SearchForm'") {
    if (autocompleteloaded) {
      return;
    }
    $.getJSON('/wp-content/themes/leadingagile/data/autocomplete.json', function (data) {
      let $input = document.querySelector(selector);
      new Awesomplete($input, { list: data });
      autocompleteloaded = true;
      $input.focus();
      $(window).on('awesomplete-selectcomplete', function (e) {
        $(formId).trigger('submit');
      });
    });
  } */

  // Navigation
  let $body = $('body'),
    $menu_toggle = $('.menu-toggle'),
    $search_toggle = $('.search-toggle');

  // Open Menu if sidebar is clicked
  $menu_toggle.on('click', (e) => {
    e.preventDefault();
    $(window).trigger('open_navigation');
  });

  // Close Menu
  let menu_close_buttons = document.querySelectorAll('.close-menu');
  if (menu_close_buttons) {
    Array.from(menu_close_buttons).map((elem) => {
      elem.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('menu-open');
      });
    });
  }

  //Toggle has_input class if query has value
  let $query = $('.query'),
    $query_container = $('.query_container');
  $query.on('input', function (e) {
    $query.val() ? $query_container.addClass('has_input') : $query_container.removeClass('has_input');
  });

  //Toggle Search Panel Open
  $search_toggle.on('click', (e) => {
    e.preventDefault();
    //initAutocomplete();
    if ($body.hasClass('search-open')) {
      $body.removeClass('search-open');
      $query.blur();
    } else {
      $body.addClass('search-open');
      $query.focus();
    }
  });

  /* if (Array.from(document.body.classList).indexOf('search') !== -1) {
    //initAutocomplete('.field-caption input[name=s]', '#searchform');
  } */

  // Close menu after link click
  $('.main-menu')
    .find('.columns li a')
    .on('click', function (e) {
      $(window).trigger('open_navigation');
      return true;
    });

  let $pencil_banner = $('.pencil-banner');
  if (typeof Cookies.get('pencil-banner-close') === 'undefined' || Cookies.get('pencil-banner-close') !== $pencil_banner.attr('id')) {
    if (parseInt($(window).width()) < 768) {
      $('.menu-toggle').css({
        top: $pencil_banner.height(),
      });
    }
    $pencil_banner.show();
  }
  $('.pencil__close').on('click', function (e) {
    e.preventDefault();
    Cookies.set('pencil-banner-close', $(this).parent().attr('id'), { expires: 14 });
    $pencil_banner.hide();
    if (parseInt($(window).width()) < 768) {
      $('.menu-toggle').css({ top: '5px' });
    }
  });

  $(window).on('open_navigation', (e, data) => {
    $('.alerts-menu').removeClass('alerts-menu--open');
    $('body').toggleClass('menu-open');
  });
})(jQuery);

var $closure_youtubeid;
var $closure_startseconds;

function loadYoutubeAPI($elem = null) {
  $closure_youtubeid = $elem.data('youtubeid');
  $closure_startseconds = $elem.data('startseconds') ? $elem.data('startseconds') : 0;

  if (typeof YT == 'undefined') {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  } else {
    onYouTubeIframeAPIReady();
  }
}

var $player;
function onYouTubeIframeAPIReady() {
  if (typeof $player !== 'object') {
    $player = new YT.Player('player', {
      height: '315',
      width: '560',
      videoId: $closure_youtubeid,
      start: $closure_startseconds,
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
      playerVars: {
        rel: 0,
      },
    });
  } else {
    $player.loadVideoById({
      videoId: $closure_youtubeid,
      startSeconds: $closure_startseconds,
    });
  }
}

function onPlayerReady(event) {
  event.target.setVolume(50);
  event.target.playVideo();
}

var done = false;
function onPlayerStateChange(event) {}
function stopVideo() {
  $player.stopVideo();
}

// add classes to support css3 selectors in old browsers
function initChildClasses() {
  jQuery('.roadmap-section .content-holder').children(':last-child').addClass('last-child');
}

class LAAlerts {
  constructor(opts) {
    this.alertsMenu = document.querySelector(opts.selector);
    if (!this.alertsMenu) {
      return;
    }
    if (localStorage.getItem('alerts') === null || localStorage.getItem('seen_alerts') === null) {
      localStorage.setItem('alerts', JSON.stringify([]));
      localStorage.setItem('seen_alerts', JSON.stringify([]));
    }
    this.toggle = this.alertsMenu.querySelector('.alerts-menu-toggle');
    this.alerts = this.alertsMenu.querySelectorAll('.alert');
    this.alertids = Array.from(this.alerts).map((alert) => {
      return alert.dataset.alertid;
    });
    this.seen_alerts = localStorage.getItem('.seen_alerts');
    this.eventCountdown = document.querySelector('#eventCountdown');
    this.isOpen = false;
    this.setUnseenCount();
    this.attachListeners();
    if (this.eventCountdown !== null) {
      this.initializeClock('eventCountdown', this.eventCountdown.dataset.deadline, this.eventCountdown.dataset.endtime);
    }
  }
  attachListeners() {
    let $this = this;

    this.toggle.addEventListener('click', (e) => {
      e.preventDefault();
      $this.alertsMenu.classList.toggle('alerts-menu--open');
      document.body.classList.toggle('alerts-open');
      $this.processAlerts();
    });
  }

  processAlerts() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      let $newly_seen_alerts = Array.from(new Set(this.alertids, this.seen_alerts));
      localStorage.setItem('seen_alerts', JSON.stringify($newly_seen_alerts));
      this.setUnseenCount();
    }
  }

  setUnseenCount() {
    let $seen = JSON.parse(localStorage.getItem('seen_alerts'));
    let $unseen = this.alertids.filter((id) => !$seen.includes(id));
    this.toggle.dataset.alertcount = $unseen.length;
    $unseen.length ? this.toggle.classList.remove('no-alerts') : this.toggle.classList.add('no-alerts');
  }

  getTimeRemaining(timestamp) {
    const total = Date.parse(timestamp) - Date.parse(new Date());
    const seconds = this.maybeAddLeadingZero(Math.floor((total / 1000) % 60));
    const minutes = this.maybeAddLeadingZero(Math.floor((total / 1000 / 60) % 60));
    const hours = this.maybeAddLeadingZero(Math.floor((total / (1000 * 60 * 60)) % 24));
    const days = this.maybeAddLeadingZero(Math.floor(total / (1000 * 60 * 60 * 24)));
    return {
      total,
      days,
      hours,
      minutes,
      seconds,
    };
  }

  initializeClock(id, deadline, endtime) {
    const endtimestamp = this.getTimeRemaining(endtime);
    if (endtimestamp.total <= 0) {
      return;
    }
    const timeinterval = setInterval(() => {
      const t = this.getTimeRemaining(deadline);
      this.eventCountdown.innerHTML =
        '<div class="top">' +
        t.days +
        ' : ' +
        t.hours +
        ' : ' +
        t.minutes +
        ' : ' +
        t.seconds +
        '</div>' +
        '<div class="bottom"><span>D</span><span>H</span><span>M</span><span>S</span></div>';
      if (t.total <= 0) {
        clearInterval(timeinterval);
        this.addLiveNowLinks();
      }
    }, 1000);
  }

  addLiveNowLinks() {
    const upcoming = document.querySelector('.alert.upcoming');
    const wrap = upcoming.querySelector('.alert-wrap');
    upcoming.querySelector('.alert-meta .button').style.display = 'none';
    const permalink = wrap.querySelector('a').href;
    this.eventCountdown.innerHTML = '<a href="' + permalink + '" class="button button--outline--light">Live Now</a>';

    const live_now = document.createElement('a');
    let main_header = document.querySelector('.main-header').querySelector('.header-right');
    live_now.href = window.live_event.permalink;
    live_now.target = '_blank';
    live_now.id = 'liveNow';
    live_now.classList.add('button', 'live', 'hide');
    live_now.text = 'Live Now';
    main_header.prepend(live_now);
  }

  maybeAddLeadingZero(value) {
    return 0 <= value < 10 ? ('0' + value).slice(-2) : value;
  }
}
window.addEventListener('DOMContentLoaded', (event) => {
  new LAAlerts({
    selector: '.alerts-menu',
  });
});
function is_touch_enabled() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

let btt = document.querySelector('.back-to-top');

if (btt && is_touch_enabled()) {
  btt.classList.add('show');
  btt.addEventListener('click', (e) => {
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
}
// Zoom Module for embedded images
class LAImageZoom {
  constructor(opts) {
    this.images = document.querySelectorAll(opts.selector);
    if (!this.images) {
      return;
    }
    this.img = null;
    this.zoom_modal = null;
    this.zoom_close = null;
    this.attachModal();
    this.attachListeners();
  }
  attachListeners() {
    let $this = this;
    Array.from(this.images).forEach((img, idx) => {
      let $img = img;
      if ($img.parentElement.nodeName == 'A') {
        return;
      }

      $img.classList.add('zoomable');
      img.addEventListener('click', function (e) {
        e.preventDefault();
        $this.img = $img;
        if ($this.img.classList.contains('zoomed')) {
          $this.closeModal();
        } else {
          $this.floatImage();
          $this.openModal();
        }
      });
    });

    this.zoom_close.addEventListener('click', function (e) {
      e.preventDefault();
      $this.closeModal();
    });
    this.zoom_modal.addEventListener('click', function (e) {
      e.preventDefault();
      $this.closeModal();
    });
    this.zoom_modal.addEventListener(
      'mousewheel',
      function (e) {
        e.preventDefault();
        $this.closeModal();
      },
      { passive: true },
    );
  }
  attachModal() {
    let wrapper = document.createElement('div');
    let zoom_modal_close = document.createElement('a');

    wrapper.className = 'la-zoom';

    zoom_modal_close.className = 'zoom_modal_close';
    zoom_modal_close.innerHTML = `<svg height="32px" version="1.1" viewBox="0 0 32 32" width="32px" style="	width: 100%; height: 40%;">
        <path fill="white" d="M30 5.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17 11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z"></path>
    </svg>`;

    zoom_modal_close.href = '#';

    wrapper.append(zoom_modal_close);

    this.zoom_modal = wrapper;
    this.zoom_close = zoom_modal_close;

    document.querySelector('.site-wrapper').append(this.zoom_modal);
  }

  floatImage() {
    Object.assign(this.img.parentNode.style, {
      position: 'relative',
      width: this.img.width + 'px',
      height: this.img.height + 'px',
    });
    let left = (window.innerWidth - this.img.naturalWidth) / 2,
      top = (window.innerHeight - this.img.naturalHeight) / 2;
    this.img.classList.add('zoomed');
    this.img.style.top = `${top}px`;
    this.img.style.left = `${left}px`;
  }

  openModal() {
    this.zoom_modal.style.visibility = 'visible';
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.img.classList.remove('zoomed');
    this.img.style.top = `0px`;
    this.img.style.left = `0px`;
    this.zoom_modal.style.visibility = 'hidden';
    document.body.style.overflow = 'auto';
  }
}
window.addEventListener('DOMContentLoaded', (event) => {
  new LAImageZoom({
    selector: '.blog-content-wrap .flex--content img',
  });
});
window.addEventListener('DOMContentLoaded', (e) => {
  const progress_bar = document.querySelector('.scroll-progress .bar');

  if (progress_bar === null) {
    return;
  }

  const main_content = document.querySelector('#main');
  const main_header = document.querySelector('.main-header');
  let page_top = main_header.clientHeight;
  let page_height = main_content.clientHeight - window.innerHeight;

  window.addEventListener('resize', (e) => {
    page_top = main_header.clientHeight;
    page_height = main_content.clientHeight - window.innerHeight;
  });

  window.addEventListener('scroll', (e) => {
    progress_bar.style.width = window.scrollY > page_top ? ((window.scrollY - page_top) / page_height) * 100 + '%' : 0;
  });
});